/* Zeero locator — "no stockist near you" WhatsApp fallback. Zeero-only.
 *
 * Two cases mean a visitor cannot buy nearby, and the fleet component only
 * surfaces the first:
 *
 *   1. the search matched nothing — the fleet shows its message, at which
 *      point it offers no way forward;
 *   2. the search worked, but the nearest stockist is another city away —
 *      no message fires, the visitor just sees "171.0 km" and leaves.
 *
 * Both are exactly the moment to hand them to a human who can still sell to
 * them, so both show one recovery line: WhatsApp, prefilled. For case 2 the
 * fleet has already computed and printed the distance on every card; this
 * reads the first card's figure (the list is distance-sorted) rather than
 * recomputing anything.
 *
 * Presentation-layer only: no fleet file is touched, no locator internals are
 * reached into, and without this script everything behaves as before. DOM is
 * built with createElement/textContent — the fleet's own no-innerHTML rule.
 */
(function () {
  "use strict";

  function init(root) {
    var error = root.querySelector("[data-sl-error]");
    var list = root.querySelector("[data-sl-list]");
    if (!error) return;

    var rescue = document.createElement("div");
    rescue.className = "sl-rescue";
    rescue.hidden = true;

    var txt = document.createElement("span");
    txt.className = "sl-rescue__txt";
    txt.textContent = "No stockist near you? We deliver nationwide.";
    rescue.appendChild(txt);

    // A real button with the WhatsApp glyph, not a sentence that happens to be
    // a link — the glyph is copied from the site's own isokae-wa-order button
    // so both surfaces read as the same control.
    var wa = document.createElement("a");
    wa.className = "sl-rescue__wa";
    wa.href = "https://wa.me/601154028839?text=" + encodeURIComponent(
      "Hi Zeero, I couldn't find a stockist near me. Can you help me get Zeero?");
    wa.target = "_blank";
    wa.rel = "noopener";
    var NS = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(NS, "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "currentColor");
    svg.setAttribute("aria-hidden", "true");
    var path = document.createElementNS(NS, "path");
    path.setAttribute("d", "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z");
    svg.appendChild(path);
    wa.appendChild(svg);
    wa.appendChild(document.createTextNode("WhatsApp us"));
    rescue.appendChild(wa);

    // After the error, so the CSS ordering keeps the pair together.
    error.parentNode.insertBefore(rescue, error.nextSibling);

    // "Far" = the nearest stockist is another city away. 50km (30mi) is past
    // any reasonable pop-to-the-pharmacy distance in Malaysia. Distances only
    // exist once a place or use-my-location search has run; before that the
    // selector finds nothing and this stays false.
    var nearestIsFar = function () {
      if (!list) return false;
      var d = list.querySelector(".sl-card__distance");
      if (!d) return false;
      var m = /([\d.]+)\s*(km|mi)/.exec(d.textContent);
      if (!m) return false;
      return parseFloat(m[1]) > (m[2] === "mi" ? 30 : 50);
    };

    var sync = function () { rescue.hidden = error.hidden && !nearestIsFar(); };
    new MutationObserver(sync).observe(error, { attributes: true, attributeFilter: ["hidden"] });
    // The fleet re-renders the list wholesale on every search, so childList
    // fires exactly once per result set.
    if (list) new MutationObserver(sync).observe(list, { childList: true });
    sync();
  }

  function boot() {
    document.querySelectorAll("[data-store-locator]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
